/** W7 GOT Location Master (legacy QCS p150–152, QCM p214–215). Round 1: screens only. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { GotLocationMasterPage } from "@/features/got/components/masters-pages";

const search = z.object({
  view: z.enum(["list", "search", "add", "edit"]).default("list"),
  id: z.number().int().optional(),
  letter: z.string().optional(),
  q: z.string().optional(),
});

export const Route = createFileRoute("/_app/masters/got-locations")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("got.locations")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const canManage = useAuth((a) => a.can("got.locations"));
  return (
    <GotLocationMasterPage
      search={s}
      canManage={canManage}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
